  <template>
    <div>
      <div class="viewer-container" :class="{ 'is-view2d': tools.view2DActive }">
        <!-- :key fuerza a Vue a recrear el <canvas> tras un viewer.destroy().
             Xeokit 2.6 deja el WebGLContext perdido y el id queda apuntando a
             un canvas inutilizable; un canvas fresco evita "Mandatory config
             expected: valid canvasId or canvasElement" al recrear el Viewer. -->
        <canvas id="myCanvas" ref="myCanvas" :key="canvasKey"></canvas>
        <canvas id="myNavCubeCanvas" :key="'nav-' + canvasKey"></canvas>

        <div v-if="loadingProgress.total >= 1"
          class="bim-loading-progress">
          <div class="bim-loading-text">
            <template v-if="loadingProgress.total > 1">
              {{ $t('loading') }} {{ loadingProgress.loaded }} {{ $t('of') }} {{ loadingProgress.total }}
            </template>
            <template v-else>
              {{ $t('loading') }}...
            </template>
          </div>

          <div class="bim-loading-bar-container">
            <div class="bim-loading-bar" :style="{ width: loadingBarWidth + '%' }"></div>
          </div>

          <div class="bim-loading-details">
            <span v-if="loadingProgress.current" class="bim-loading-current">{{ $t('process') }}: {{ loadingProgress.current
            }}</span>
            <span v-if="loadingProgress.downloadPct > 0 && loadingProgress.downloadPct < 100" class="bim-loading-current">
              {{ $t('download') }}: {{ loadingProgress.downloadPct }}%
            </span>
          </div>

          <button v-if="loadingProgress.loaded < loadingProgress.total" class="bim-loading-stop" @click="cancelLoading"
            :title="$t('stop_loading')">{{ $t('cancel') }}</button>
        </div>

        <div v-if="bimPopup.visible" class="bim-popup" :style="{ left: bimPopup.x + 'px', top: bimPopup.y + 'px' }">
          <div class="bim-popup-name">{{ bimPopup.name }}</div>
          <div class="bim-popup-uuid">{{ bimPopup.globalId }}</div>
        </div>

        <div v-if="unsavedElements > 0" class="bim-embed-bar">
          <div class="bim-embed-info">
            <div class="bim-embed-count">{{ unsavedElements }}</div>
            <span>{{ $t('bim_progress_pending') }}</span>
          </div>
          <button class="bim-embed-btn" @click="embedAllProgress"
            :disabled="progressSyncState === 'saving' || !canEmbed">
            <i class="fa" :class="progressSyncState === 'saving' ? 'fa-spinner fa-spin' : 'fa-plus'"></i>
            {{ progressSyncState === 'saving' ? $t('bim_progress_embedding') : $t('bim_progress_add') }}
          </button>
          <button class="bim-embed-cancel" @click="discardPendingProgress"
            :disabled="progressSyncState === 'saving'"
            :title="$t('bim_progress_discard')">
            <i class="fa fa-times"></i>
          </button>
        </div>


        <div class="left-panel">
          <div class="tools left">
            <button class="fa fa-sitemap" :class="tools.treeViewActive ? 'active' : ''" @click="toogleTreeView()">
            </button>
          </div>
          <div class="panel-box" v-show="tools.treeViewActive">
            <!-- Tabs del panel: Estructura / Propiedades. -->
            <div class="panel-tabs">
              <button
                type="button"
                class="panel-tab"
                :class="{ active: activePanelTab === 'tree' }"
                @click="activePanelTab = 'tree'"
              >
                <i class="fa fa-sitemap"></i>
                <span>{{ $t('bim_ifc_structure') }}</span>
              </button>
              <button
                type="button"
                class="panel-tab"
                :class="{ active: activePanelTab === 'properties' }"
                @click="activePanelTab = 'properties'"
              >
                <i class="fa fa-info-circle"></i>
                <span>{{ $t('bim_properties') }}</span>
                <span v-if="currentMetaObjectData" class="panel-tab-dot"></span>
              </button>
            </div>

            <!-- TAB: Estructura IFC con búsqueda -->
            <div v-show="activePanelTab === 'tree'" class="panel-tab-pane">
              <div class="tree-search">
                <i class="fa fa-search tree-search-icon"></i>
                <input
                  type="text"
                  v-model="treeSearchQuery"
                  @input="_filterTree"
                  :placeholder="$t('search') + '...'"
                  class="tree-search-input"
                />
                <button
                  v-if="treeSearchQuery"
                  type="button"
                  class="tree-search-clear"
                  @click="treeSearchQuery = ''; _filterTree()"
                  :title="$t('cancel')"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="panel-content treeview">
                <div v-if="isBuildingTree" style="padding: 20px; text-align: center; color: #9aa0ab;">
                  <i class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i> {{ $t('loading') }}...
                </div>
                <div id="treeViewContainer" v-show="!isBuildingTree"></div>
              </div>
            </div>

            <div v-show="activePanelTab === 'properties'" class="panel-tab-pane">
              <div v-if="!currentMetaObjectData" class="panel-empty">
                <i class="fa fa-mouse-pointer panel-empty-icon"></i>
                <p>{{ $t('bim_select_element_hint') }}</p>
              </div>
              <template v-else>
  
              <div class="bim-progress-card is-fixed-top">
                <div class="bim-progress-header" @click="toggleDropdown('_avance')">
                  <i class="fa fa-chart-bar bim-progress-header-icon"></i>
                  <span>{{ $t('bim_progress_section') }}</span>
                  <span v-if="currentElementProgress.percentage !== null && currentElementProgress.percentage > 0"
                    class="bim-progress-badge"
                    :style="{ background: currentElementProgress.color || 'rgba(255,255,255,0.2)' }">
                    {{ currentElementProgress.percentage }}%
                  </span>
                  <i class="fa bim-progress-chevron"
                    :class="showMetaObjectProps['_avance'] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>

                <div class="bim-progress-body" v-show="showMetaObjectProps['_avance']">
                  <div class="bim-progress-row">
                    <div class="bim-pct-input-wrap">
                      <input
                        type="number"
                        class="bim-pct-input"
                        min="0" max="100" step="1"
                        v-model.number="currentPercentage"
                        placeholder="0"
                      />
                      <span class="bim-pct-symbol">%</span>
                    </div>
                    <div class="bim-pct-bar-track">
                      <div class="bim-pct-bar-fill"
                        :style="{ width: (currentElementProgress.percentage || 0) + '%', background: currentElementProgress.color || '#9aa0ab' }">
                      </div>
                    </div>
                  </div>

                  <div class="bim-swatches">
                    <button
                      v-for="c in progressColorPresets"
                      :key="c.value"
                      type="button"
                      class="bim-swatch"
                      :class="{ selected: currentElementProgress.color === c.value }"
                      :title="c.label"
                      @click="setCurrentProgress('color', c.value)"
                    >
                      <span class="bim-swatch-dot" :style="{ background: c.value }">
                        <i v-if="currentElementProgress.color === c.value" class="fa fa-check bim-swatch-check"></i>
                      </span>
                      <span class="bim-swatch-lbl">{{ c.label }}</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Scroll único para Atributos + Acciones + Propertysets -->
              <div class="panel-content panel-properties">
                <!-- Atributos básicos -->
                <div class="property">
                  <div class="property-title">
                    {{ $t('attributes') }}
                    <button @click="toggleDropdown('basic')" class="dropdown-button">
                      <i :class="showMetaObjectProps['basic'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    </button>
                  </div>
                  <div class="property-details" v-show="showMetaObjectProps['basic']">
                    <div class="property-info">
                      <span class="property-info-name">{{ $t('name') }}</span>
                      <span class="property-info-value">{{ currentMetaObjectData.name }}</span>
                    </div>
                    <div class="property-info">
                      <span class="property-info-name">{{ $t('type') }}</span>
                      <span class="property-info-value">{{ currentMetaObjectData.type }}</span>
                    </div>
                    <div class="property-info">
                      <span class="property-info-name">UUID</span>
                      <span class="property-info-value">{{ currentMetaObjectData.id }}</span>
                    </div>
                  </div>
                </div>

                <!-- Property sets: colapsados por defecto, headers sticky dentro del scroll -->
                <div class="property" v-for="p in currentMetaObjectData?.propertySets.filter(p => !!p)" :key="p.name">
                  <div class="property-title is-sticky" @click="toggleDropdown(p.name)">
                    <span>
                      {{ p.name }}
                      <span class="property-count" v-if="p.properties && p.properties.length">
                        ({{ p.properties.length }})
                      </span>
                    </span>
                    <button class="dropdown-button" @click.stop="toggleDropdown(p.name)">
                      <i :class="showMetaObjectProps[p.name] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    </button>
                  </div>
                  <div class="property-details" v-show="showMetaObjectProps[p.name]">
                    <div class="property-info" v-for="pp in p?.properties" :key="pp.name">
                      <span class="property-info-name">{{ pp.name }}</span>
                      <span class="property-info-value">{{ pp.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
              </template>
            </div>
          </div>
        </div>

        <div class="tools right">
          <button class="fa fa-home" @click="resetAll()"></button>
          <button class="fa fa-th" :class="tools.cameraOrthoActive ? 'active' : ''" @click="toogleCameraOrtho()"></button>
          <button class="fa fa-map" :class="tools.view2DActive ? 'active' : ''" :title="$t('bim_view_2d')" @click="goTopView2D()"></button>
          <button class="fa fa-arrow-down-up-across-line" :class="tools.sectionPlanesActive ? 'active' : ''"
            @click="toogleSectionPlanesTool()"></button>
          <button class="fa fa-eraser" :class="tools.hideObjectActive ? 'active' : ''"
            @click="toogleHideObjectTool()"></button>
          <button class="fa fa-mouse-pointer" :class="tools.selectObjectActive ? 'active' : ''"
            @click="toogleSelectObjectTool()"></button>
          <button class="fa fa-ruler" :class="tools.distanceMeasurementToolActive ? 'active' : ''"
            @click="toogleMeasurementDistanceTool()"></button>
          <button class="fa fa-chevron-left" :class="tools.angleMeasurementToolActive ? 'active' : ''"
            @click="toogleMeasurementAngleTool()"></button>
        </div>
      </div>
    </div>
  </template>

  <script>
  import {
    Viewer,
    NavCubePlugin,
    AngleMeasurementsPlugin,
    DistanceMeasurementsPlugin,
    XKTLoaderPlugin,
    AngleMeasurementsMouseControl,
    DistanceMeasurementsMouseControl,
    SectionPlanesPlugin,
    ContextMenu,
    TreeViewPlugin,
    FastNavPlugin,
    math
  } from "@xeokit/xeokit-sdk";
  import axios from 'axios';

  // Constantes del modo "Vista 2D Blueprint". Inmutables, definidas a nivel
  // de módulo para no recrearlas en cada llamada a goTopView2D().
  const ELECTRICAL_IFC_TYPES = Object.freeze(new Set([
    'IfcElectricAppliance', 'IfcLightFixture', 'IfcOutlet', 'IfcSwitchingDevice',
    'IfcCableCarrierFitting', 'IfcCableCarrierSegment', 'IfcCableSegment',
    'IfcCableFitting', 'IfcDistributionElement', 'IfcDistributionControlElement',
    'IfcElectricDistributionBoard', 'IfcElectricFlowStorageDevice',
    'IfcElectricGenerator', 'IfcElectricMotor', 'IfcProtectiveDevice',
    'IfcJunctionBox', 'IfcTransformer', 'IfcSensor',
  ]));
  const BLUEPRINT_BG_RGB         = [0.04, 0.07, 0.13];
  const BLUEPRINT_EDGE_RGB       = [0.45, 0.85, 1.0];
  const BLUEPRINT_EDGE_ALPHA     = 0.85;
  const BLUEPRINT_EDGE_WIDTH     = 1.5;
  const ELECTRICAL_HIGHLIGHT_RGB = [1.00, 0.78, 0.17];

  export default {
    name: "BimViewer",

    data() {
      return {
        viewerReady: false,
        isBuildingTree: false,

        tools: {
          treeViewActive: false,
          angleMeasurementToolActive: false,
          distanceMeasurementToolActive: false,
          selectObjectActive: false,
          hideObjectActive: false,
          sectionPlanesActive: false,
          cameraOrthoActive: false,
          view2DActive: false,
        },
        currentToolEnabled: null,

        bimPopup: {
          visible: false,
          x: 0,
          y: 0,
          globalId: null,
          name: ''
        },

        loadingProgress: { loaded: 0, total: 0, current: '', downloadPct: 0 },
        loadingCancelled: false,
        treeViewDirty: false,

        leftMenu: {
          tree: true,
          properties: true,
        },

        // Pestaña activa del panel izquierdo: 'tree' | 'properties'.
        activePanelTab: 'tree',
        treeSearchQuery: '',
        canvasKey: 0,

        currentMetaObjectData: null,
        showMetaObjectProps: {},

        // Avance por elemento: { [globalId]: { percentage: number|null, color: string|null } }
        // Contiene tanto los datos precargados desde el IFC como las ediciones del usuario.
        elementProgressMap: {},
        // IDs de elementos que el usuario ha modificado en esta sesión (aún no incrustados).
        // Solo esto se usa para el contador de la barra amarilla.
        dirtyElementIds: {},
        // Estado del autosave: 'idle' | 'saving' | 'error'
        progressSyncState: 'idle',
        // Color activo del filtro por avance (null = sin filtro, todos visibles).
        progressColorFilter: null,
      };
    },

    created() {
      this.viewer = null;
      this.loader = null;
      this.sceneModels = [];
      this._loadGeneration = 0;
      this.treeView = null;
      this.treeViewContextMenu = null;
      this.angleMeasurements = null;
      this.angleMeasurementsMouseControl = null;
      this.distanceMeasurements = null;
      this.distanceMeasurementsMouseControl = null;
      this._annotationsOverlay = null;
      this._annotations = [];
      this._annotationTickHandle = undefined;
      this._filterColorizedIds = [];

      this.xktBufferCache = {};
      this.xktCacheMaxBytes = 10 * 1024 * 1024;
      this._pendingTreeSync = null;
      this._xeokitLayerPatched = false;
    },

    async mounted() {
      if (this.effectiveUrls && this.effectiveUrls.length > 0) {
        await this.handleFileUploads(this.effectiveUrls);
      } else {
        await this.initViewer();
      }
    },

    props: {
      url: {
        type: String,
        default: null
      },
      urls: {
        type: Array,
        default: null
      },
      federated: {
        type: Boolean,
        default: false
      },
      documentId: {
        type: Number,
        default: null
      },
      documentIds: {
        type: Array,
        default: null
      }
    },

    computed: {
      effectiveUrls() {
        if (this.urls && this.urls.length > 0) return this.urls;
        if (this.url) return [this.url];
        return [];
      },
      loadingBarWidth() {
        const p = this.loadingProgress;
        if (p.total <= 0) return 0;
        if (p.total === 1) {
          return p.downloadPct > 0 ? p.downloadPct : (p.loaded / p.total * 100);
        }
        return (p.loaded / p.total * 100);
      },

      currentElementProgress() {
        const id = this.currentMetaObjectData?.id;
        if (!id) return { percentage: null, color: null };
        return this.elementProgressMap[id] || { percentage: null, color: null };
      },

      currentPercentage: {
        get() {
          const v = this.currentElementProgress.percentage;
          return (v === null || v === undefined || v === '') ? null : Number(v);
        },
        set(value) {
          const id = this.currentMetaObjectData?.id;
          if (!id) return;
          let v = value;
          if (v === '' || v === null || v === undefined || Number.isNaN(Number(v))) v = null;
          else v = Math.max(0, Math.min(100, Number(v)));
          const current = this.elementProgressMap[id] || { percentage: null, color: null };
          this._upsertProgress(id, { ...current, percentage: v });
        },
      },

      unsavedElements() {
        return Object.keys(this.dirtyElementIds).length;
      },

      progressColorPresets() {
        return [
          { value: '#9e9e9e', label: this.$t('bim_progress_status_not_started') },
          { value: '#f9c72c', label: this.$t('bim_progress_status_in_progress') },
          { value: '#4caf50', label: this.$t('bim_progress_status_completed') },
          { value: '#f44336', label: this.$t('bim_progress_status_issue') },
        ];
      },

      progressCountsByColor() {
        const counts = {};
        for (const id in this.elementProgressMap) {
          const c = this.elementProgressMap[id]?.color;
          if (!c) continue;
          counts[c] = (counts[c] || 0) + 1;
        }
        return counts;
      },

      embedTargetIds() {
        if (Array.isArray(this.documentIds) && this.documentIds.length > 0) return this.documentIds;
        if (this.documentId) return [this.documentId];
        return [];
      },

      canEmbed() {
        return this.embedTargetIds.length > 0;
      },
    },

    watch: {
      effectiveUrls: {
        async handler(newUrls) {
          if (newUrls && newUrls.length > 0) {
            await this.handleFileUploads(newUrls);
          }
        }
      },
      progressCountsByColor: {
        immediate: true,
        handler(counts) { this.$emit('progress-counts', counts); },
      },
      progressColorFilter: {
        immediate: true,
        handler(color) { this.$emit('progress-filter', color); },
      },
      unsavedElements: {
        immediate: true,
        handler(n) { this.$emit('progress-unsaved', n); },
      },
      progressSyncState: {
        immediate: true,
        handler(s) { this.$emit('progress-sync-state', s); },
      },
      activePanelTab(newTab) {
        if (newTab !== 'tree') return;
        this.$nextTick(() => {
          const container = document.getElementById('treeViewContainer');
          const selected = container?.querySelector('.bim-tree-selected');
          if (selected) selected.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      },
    },

    methods: {
      toggleDropdown(name) {
        this.$set(this.showMetaObjectProps, name, !this.showMetaObjectProps[name]);
      },

      // Asegura que el canvas captura wheel-events sin que la página haga scroll.
      // Idempotente: si ya está marcado, no re-adjunta.
      _attachCanvasWheelListener(canvasEl) {
        if (!canvasEl || canvasEl._wheelAttached) return;
        canvasEl.addEventListener(
          "wheel",
          (e) => { e.stopPropagation(); e.preventDefault(); },
          { passive: false }
        );
        canvasEl._wheelAttached = true;
      },

      async initViewer() {
        // Si venimos de un destroyAll, canvasKey se incrementó y Vue todavía no
        // pintó el nuevo <canvas>; esperamos a nextTick para que esté en DOM.
        // En el primer mount es no-op (canvasKey=0 ya está pintado).
        await this.$nextTick();

        // Pasamos el ref directo en vez de canvasId. Evita depender de un
        // document.getElementById que falla si Vue acaba de reemplazar el nodo.
        const canvasEl = this.$refs.myCanvas;
        if (!canvasEl) {
          console.warn('[BimViewer] canvas ref no disponible al iniciar Viewer');
          return;
        }

        this._attachCanvasWheelListener(canvasEl);

        this.viewer = new Viewer({
          canvasElement: canvasEl,
          transparent: true,
          dtxEnabled: true,
          antialias: false,
          preserveDrawingBuffer: false
        });

        this.viewer.scene.sao.enabled = false;
        this.viewer.scene.edgesEnabled = false;
        this.viewer.scene.pbrEnabled = false;
        this.viewer.scene.colorTextureEnabled = false;
        this.viewer.scene.gammaInput = false;
        this.viewer.scene.gammaOutput = false;
        this.viewer.scene.renderingTransparentObjectsLast = true;

        this.viewer.camera.eye = [-2.56, 8.38, 8.27];
        this.viewer.camera.look = [13.44, 3.31, -14.83];
        this.viewer.camera.up = [0.10, 0.98, -0.14];
        this.viewer.cameraControl.panRightClick = false;

        this.viewer.scene.xrayMaterial.fill = true;
        this.viewer.scene.xrayMaterial.edges = false;
        this.viewer.scene.xrayMaterial.fillAlpha = 0.1;
        this.viewer.scene.xrayMaterial.fillColor = [0, 0, 0];
        this.viewer.scene.xrayMaterial.edgeAlpha = 0.3;
        this.viewer.scene.xrayMaterial.edgeColor = [0, 0, 0];

        this.viewer.scene.highlightMaterial.fill = true;
        this.viewer.scene.highlightMaterial.edges = false;
        this.viewer.scene.highlightMaterial.fillAlpha = 0.1;
        this.viewer.scene.highlightMaterial.edgeAlpha = 0.1;
        this.viewer.scene.highlightMaterial.edgeColor = [1, 1, 0];

        this.viewer.scene.selectedMaterial.fill = true;
        this.viewer.scene.selectedMaterial.edges = true;
        this.viewer.scene.selectedMaterial.fillAlpha = 0.2;
        this.viewer.scene.selectedMaterial.edgeAlpha = 0.6;
        this.viewer.scene.selectedMaterial.edgeColor = [0, 1, 1];

        this.viewer.cameraControl.followPointer = true;

        this.createNavCube();
        this.createMeasurementAngleTool();
        this.createMeasurementDistanceTool();
        this.createSelectObjectTool();
        this.createHideObjectTool();
        this.createSectionPlanesTool();
        this.createCanvasContextMenu();
        this.treeViewDirty = true;

        const fastNavPlugin = new FastNavPlugin(this.viewer, {
          hideEdges: true,
          hideSAO: true,
          hideColorTexture: true,
          hidePBR: true,
          hideTransparentObjects: false,
          scaleCanvasResolution: true,
          defaultScaleCanvasResolutionFactor: 1.0,
          scaleCanvasResolutionFactor: 0.5,
          delayBeforeRestore: true,
          delayBeforeRestoreSeconds: 0.4
        });

        this.loader = new XKTLoaderPlugin(this.viewer, {
          workerPoolSize: 4,
          maxGeometryBatchSize: 50000,
          objectDefaults: { visible: true },
          includeTypes: undefined,
          excludeUnclassifiedObjects: false
        });

        this.viewer.scene.canvas.backgroundColor = [0.1, 0.1, 0.1];
        this.viewer.cameraFlight.flyTo(this.viewer.scene);

        this.viewerReady = true;

        var lastEntity = null;
        const canvas = this.viewer.scene.canvas.canvas;

        this.viewer.cameraControl.on("hover", function (pickResult) {
          try {
            if (pickResult && pickResult.entity) {
              canvas.style.cursor = "pointer";
              if (!lastEntity || pickResult.entity.id !== lastEntity.id) {
                if (lastEntity) lastEntity.highlighted = false;
                lastEntity = pickResult.entity;
                pickResult.entity.highlighted = true;
              }
            } else {
              canvas.style.cursor = "default";
              if (lastEntity) {
                lastEntity.highlighted = false;
                lastEntity = null;
              }
            }
          } catch (_) {
            canvas.style.cursor = "default";
            lastEntity = null;
          }
        });
      },

      createNavCube() {
        new NavCubePlugin(this.viewer, {
          canvasId: "myNavCubeCanvas",
          visible: true,
          cameraFly: true,
          cameraFitFOV: 30,
          cameraFlyDuration: 0.5, 
          textColor: "#2f374a"
        });
      },

      createTreeView() {
        if (this.treeView) {
          this.treeView.destroy();
          this.treeView = null;
        }
        if (this.treeViewContextMenu) {
          this.treeViewContextMenu.destroy();
          this.treeViewContextMenu = null;
        }

        const container = document.getElementById("treeViewContainer");
        if (container) container.innerHTML = '';


        this.treeView = new TreeViewPlugin(this.viewer, {
          containerElement: document.getElementById("treeViewContainer"),
          autoExpandDepth: 2,
          hierarchy: "containment"
        });

        const vm = this;
        this.treeViewContextMenu = new ContextMenu({
          enabled: true,
          items: [
            [
              {
                title: vm.$t('bim_view_fit'),
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  const objectIds = [];
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      objectIds.push(treeViewNode.objectId);
                    }
                  });
                  scene.setObjectsVisible(objectIds, true);
                  scene.setObjectsHighlighted(objectIds, true);
                  context.viewer.cameraFlight.flyTo({
                    projection: "perspective",
                    aabb: scene.getAABB(objectIds),
                    duration: 0.5
                  }, () => {
                    setTimeout(function () {
                      scene.setObjectsHighlighted(scene.highlightedObjectIds, false);
                    }, 500);
                  });
                }
              },
              {
                title: vm.$t('bim_view_fit_all'),
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  context.viewer.cameraFlight.flyTo({
                    projection: "perspective",
                    aabb: scene.getAABB({}),
                    duration: 0.5
                  });
                }
              }
            ],
            [
              {
                title: vm.$t('hide'),
                doAction: function (context) {
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = context.viewer.scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.visible = false;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_hide_others'),
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsVisible(scene.visibleObjectIds, false);
                  scene.setObjectsXRayed(scene.xrayedObjectIds, false);
                  scene.setObjectsSelected(scene.selectedObjectIds, false);
                  scene.setObjectsHighlighted(scene.highlightedObjectIds, false);
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.visible = true;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_hide_all'),
                getEnabled: function (context) {
                  return (context.viewer.scene.visibleObjectIds.length > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsVisible(context.viewer.scene.visibleObjectIds, false);
                }
              }
            ],
            [
              {
                title: vm.$t('bim_show'),
                doAction: function (context) {
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = context.viewer.scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.visible = true;
                        entity.xrayed = false;
                        entity.selected = false;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_show_others'),
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsVisible(scene.objectIds, true);
                  scene.setObjectsXRayed(scene.xrayedObjectIds, false);
                  scene.setObjectsSelected(scene.selectedObjectIds, false);
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.visible = false;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_show_all'),
                getEnabled: function (context) {
                  const scene = context.viewer.scene;
                  return (scene.numVisibleObjects < scene.numObjects);
                },
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsVisible(scene.objectIds, true);
                  scene.setObjectsXRayed(scene.xrayedObjectIds, false);
                  scene.setObjectsSelected(scene.selectedObjectIds, false);
                }
              }
            ],
            [
              {
                title: vm.$t('bim_xray'),
                doAction: function (context) {
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = context.viewer.scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.xrayed = true;
                        entity.visible = true;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_undo_xray'),
                doAction: function (context) {
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = context.viewer.scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.xrayed = false;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_xray_others'),
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsVisible(scene.objectIds, true);
                  scene.setObjectsXRayed(scene.objectIds, true);
                  scene.setObjectsSelected(scene.selectedObjectIds, false);
                  scene.setObjectsHighlighted(scene.highlightedObjectIds, false);
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.xrayed = false;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_reset_xray'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numXRayedObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsXRayed(context.viewer.scene.xrayedObjectIds, false);
                }
              }
            ],
            [
              {
                title: vm.$t('select'),
                doAction: function (context) {
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = context.viewer.scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.selected = true;
                        entity.visible = true;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_deselect'),
                doAction: function (context) {
                  context.treeViewPlugin.withNodeTree(context.treeViewNode, (treeViewNode) => {
                    if (treeViewNode.objectId) {
                      const entity = context.viewer.scene.objects[treeViewNode.objectId];
                      if (entity) {
                        entity.selected = false;
                      }
                    }
                  });
                }
              },
              {
                title: vm.$t('bim_clear_selection'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numSelectedObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsSelected(context.viewer.scene.selectedObjectIds, false);
                }
              }
            ]
          ]
        });

        this.treeView.on("contextmenu", (e) => {
          this.treeViewContextMenu.context = {
            viewer: e.viewer,
            treeViewPlugin: e.treeViewPlugin,
            treeViewNode: e.treeViewNode,
            entity: e.viewer.scene.objects[e.treeViewNode.objectId]
          };
          this.treeViewContextMenu.show(e.event.pageX, e.event.pageY);
        });

        this.treeView.on("nodeTitleClicked", (e) => {
          const objectId = e.treeViewNode.objectId;
          this._loadElementProperties(objectId);
          this._highlightTreeSpan(objectId);

          const scene = this.viewer.scene;
          const objectIds = [];
          e.treeViewPlugin.withNodeTree(e.treeViewNode, (treeViewNode) => {
            if (treeViewNode.objectId && scene.objects[treeViewNode.objectId]) {
              objectIds.push(treeViewNode.objectId);
            }
          });

          if (objectIds.length > 0) {
            if (scene.numSelectedObjects > 0) {
              scene.setObjectsSelected(scene.selectedObjectIds, false);
            }
            scene.setObjectsSelected(objectIds, true);

            this.viewer.cameraFlight.flyTo({
              aabb: scene.getAABB(objectIds),
              duration: 0.5,
              fitFOV: 45
            });
          }
        });
        this._flattenWrapperLevels();

        // Re-aplicar el filtro de búsqueda si quedó activo de antes
        if (this.treeSearchQuery) this._filterTree();
      },
      _flattenWrapperLevels() {
        const container = document.getElementById("treeViewContainer");
        if (!container || !this.viewer?.metaScene) return;

        const metaObjects = this.viewer.metaScene.metaObjects;

        const wrapperTypes = new Set(['ifcproject', 'ifcsite']);
        const wrapperIds = Object.keys(metaObjects)
          .filter(id => wrapperTypes.has((metaObjects[id]?.type || '').toLowerCase()));

        for (const wrapperId of wrapperIds) {
          const li = this._findTreeLi(container, wrapperId);
          if (li) this._flattenLi(li);
        }

        const rootUl = container.querySelector('ul');
        const isCodeName = (name) => {
          if (!name) return false;
          const trimmed = name.trim();
          if (!/[a-zA-ZáéíóúñÁÉÍÓÚÑ]/.test(trimmed)) return true;
          if (/[_-](XXX|YYY|ZZZ)$/i.test(trimmed)) return true;
          return false;
        };

        for (let pass = 0; pass < 5 && rootUl; pass++) {
          const topLis = Array.from(rootUl.children).filter(c => c.tagName === 'LI');
          let changedThisPass = 0;
          for (const li of topLis) {
            const span = li.querySelector(':scope > span');
            const name = span?.textContent || '';
            if (!isCodeName(name)) continue;
            if (this._flattenLi(li)) changedThisPass++;
          }
          if (changedThisPass === 0) break;
        }
      },

      // Helper: promueve los hijos del <li> al padre y elimina el wrapper.
      // Devuelve true si se aplanó, false si no se pudo.
      _flattenLi(li) {
        const parentEl = li?.parentElement;
        if (!parentEl) return false;
        const childUl = li.querySelector(':scope > ul');
        if (childUl) {
          while (childUl.firstChild) {
            parentEl.insertBefore(childUl.firstChild, li);
          }
        }
        parentEl.removeChild(li);
        return true;
      },

      toogleTreeView() {
        this.tools.treeViewActive = !this.tools.treeViewActive;

        if (this.tools.treeViewActive && this.treeViewDirty && this.viewer) {
          this.isBuildingTree = true;

          // requestAnimationFrame obliga al navegador a pintar los cambios visuales en pantalla
          requestAnimationFrame(() => {
            // El setTimeout da un margen minúsculo para que Firefox reinicie su contador de "cuelgue"
            setTimeout(() => {
              this.createTreeView();
              this.treeViewDirty = false;
              this.isBuildingTree = false;
              // Sincronizar si hay un nodo pendiente de una selección en el visor
              if (this._pendingTreeSync) {
                this._showAndHighlightNode(this._pendingTreeSync);
                this._pendingTreeSync = null;
              }
            }, 300); // Subimos un poco a 300ms para asegurar que respire
          });
        }
      },

      createCanvasContextMenu() {
        const vm = this;
        const objectContextMenu = new ContextMenu({
          items: [
            [
              {
                getTitle: (context) => {
                  return (context.entity.visible) ? vm.$t('hide') : vm.$t('bim_undo_hide');
                },
                getShown: (context) => {
                  return (!!context.entity);
                },
                doAction: function (context) {
                  context.entity.visible = !context.entity.visible;
                }
              },
              {
                getTitle: (context) => {
                  return vm.$t('bim_hide_all') + " (" + context.viewer.scene.numVisibleObjects + " " + vm.$t('bim_shown') + ")";
                },
                getEnabled: function (context) {
                  return (context.viewer.scene.numVisibleObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsVisible(context.viewer.scene.visibleObjectIds, false);
                }
              },
              {
                getTitle: (context) => {
                  return vm.$t('bim_show_all') + " (" + (context.viewer.scene.numObjects - context.viewer.scene.numVisibleObjects) + " " + vm.$t('bim_hidden') + ")";
                },
                getEnabled: function (context) {
                  const scene = context.viewer.scene;
                  return (scene.numVisibleObjects < scene.numObjects);
                },
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsVisible(scene.objectIds, true);
                  scene.setObjectsXRayed(scene.xrayedObjectIds, false);
                  scene.setObjectsSelected(scene.selectedObjectIds, false);
                }
              }
            ],
            [
              {
                getTitle: (context) => {
                  return (!context.entity.xrayed) ? vm.$t('bim_xray') : vm.$t('bim_undo_xray');
                },
                getShown: (context) => {
                  return (!!context.entity);
                },
                doAction: function (context) {
                  context.entity.xrayed = !context.entity.xrayed;
                }
              },
              {
                title: vm.$t('bim_reset_xray'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numXRayedObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsXRayed(context.viewer.scene.xrayedObjectIds, false);
                }
              }
            ],
            [
              {
                getTitle: (context) => {
                  return (!context.entity.selected) ? vm.$t('select') : vm.$t('bim_undo_select');
                },
                getShown: (context) => {
                  return (!!context.entity);
                },
                doAction: function (context) {
                  context.entity.selected = !context.entity.selected;
                }
              },
              {
                title: vm.$t('bim_clear_selection'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numSelectedObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsSelected(context.viewer.scene.selectedObjectIds, false);
                }
              }
            ]
          ],
          enabled: true
        });

        const canvasContextMenu = new ContextMenu({
          enabled: true,
          context: {
            viewer: this.viewer
          },
          items: [
            [
              {
                title: vm.$t('bim_view_fit_all'),
                doAction: function (context) {
                  context.viewer.cameraFlight.flyTo({
                    aabb: context.viewer.scene.getAABB()
                  });
                }
              }
            ],
            [
              {
                title: vm.$t('bim_xray_all'),
                getEnabled: function (context) {
                  const scene = context.viewer.scene;
                  return (scene.numXRayedObjects < scene.numObjects);
                },
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsXRayed(scene.objectIds, true);
                }
              },
              {
                title: vm.$t('bim_xray_none'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numXRayedObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsXRayed(context.viewer.scene.xrayedObjectIds, false);
                }
              }
            ],
            [
              {
                title: vm.$t('bim_hide_all'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numVisibleObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsVisible(context.viewer.scene.visibleObjectIds, false);
                }
              },
              {
                title: vm.$t('bim_show_all'),
                getEnabled: function (context) {
                  const scene = context.viewer.scene;
                  return (scene.numVisibleObjects < scene.numObjects);
                },
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsVisible(scene.objectIds, true);
                  scene.setObjectsXRayed(scene.xrayedObjectIds, false);
                  scene.setObjectsSelected(scene.selectedObjectIds, false);
                }
              }
            ],
            [
              {
                title: vm.$t('select_all'),
                getEnabled: function (context) {
                  const scene = context.viewer.scene;
                  return (scene.numSelectedObjects < scene.numObjects);
                },
                doAction: function (context) {
                  const scene = context.viewer.scene;
                  scene.setObjectsSelected(scene.objectIds, true);
                }
              },
              {
                title: vm.$t('bim_select_none'),
                getEnabled: function (context) {
                  return (context.viewer.scene.numSelectedObjects > 0);
                },
                doAction: function (context) {
                  context.viewer.scene.setObjectsSelected(context.viewer.scene.selectedObjectIds, false);
                }
              }
            ]
          ]
        });

        // Single click: NO hace nada salvo cerrar el popup si está abierto.
        // Sin selección, sin carga de props, sin cambio de tab, sin volar
        // cámara. Esto deja la navegación 100% libre de sorpresas.
        this.viewer.scene.canvas.canvas.addEventListener('click', (event) => {
          if (event.button !== 0) return;
          if (this.bimPopup.visible) this.bimPopup.visible = false;
        });

        // Doble click: acción explícita del usuario para inspeccionar el
        // objeto. Aquí pasa TODO: popup, carga de propiedades, sync con árbol,
        // cambio a pestaña Propiedades y vuelo de cámara.
        this.viewer.scene.canvas.canvas.addEventListener('dblclick', (event) => {
          if (event.button !== 0) return;
          try {
            const canvasPos = this.getCanvasPosFromEvent(event);
            const hit = this.viewer.scene.pick({ canvasPos });
            if (!(hit && hit.entity && hit.entity.isObject)) {
              this.bimPopup.visible = false;
              return;
            }
            const metaObject = this.viewer.metaScene?.metaObjects[hit.entity.id];
            const globalId = metaObject?.id || null;
            if (!globalId) {
              this.bimPopup.visible = false;
              return;
            }

            const rect = this.viewer.scene.canvas.canvas.getBoundingClientRect();
            this.bimPopup = {
              visible: true,
              x: event.clientX - rect.left + 10,
              y: event.clientY - rect.top - 10,
              globalId,
              name: metaObject?.name || globalId,
            };

            this._loadElementProperties(hit.entity.id);
            this._syncSelectionToTree(hit.entity.id);
            this.activePanelTab = 'properties';

            this.viewer.cameraFlight.flyTo({
              aabb: hit.entity.aabb,
              duration: 0.5,
              fitFOV: 45,
            });
          } catch (_) {
            this.bimPopup.visible = false;
          }
        });

        this.viewer.scene.canvas.canvas.addEventListener('contextmenu', (event) => {
          const canvasPos = this.getCanvasPosFromEvent(event);
          const hit = this.viewer.scene.pick({
            canvasPos
          });
          if (hit && hit.entity.isObject) {
            objectContextMenu.context = {
              viewer: this.viewer,
              entity: hit.entity
            };
            objectContextMenu.show(event.pageX, event.pageY);
          } else {
            canvasContextMenu.context = {
              viewer: this.viewer
            };
            canvasContextMenu.show(event.pageX, event.pageY);
          }
          event.preventDefault();
        });
      },

      getCanvasPosFromEvent(event) {
        const canvasPos = [];
        if (!event) {
          event = window.event;
          canvasPos[0] = event.x;
          canvasPos[1] = event.y;
        } else {
          let element = event.target;
          let totalOffsetLeft = 0;
          let totalOffsetTop = 0;
          let totalScrollX = 0;
          let totalScrollY = 0;
          while (element.offsetParent) {
            totalOffsetLeft += element.offsetLeft;
            totalOffsetTop += element.offsetTop;
            totalScrollX += element.scrollLeft;
            totalScrollY += element.scrollTop;
            element = element.offsetParent;
          }
          canvasPos[0] = event.pageX + totalScrollX - totalOffsetLeft;
          canvasPos[1] = event.pageY + totalScrollY - totalOffsetTop;
        }
        return canvasPos;
      },

      createMeasurementAngleTool() {
        this.angleMeasurements = new AngleMeasurementsPlugin(this.viewer);
        this.angleMeasurementsMouseControl = new AngleMeasurementsMouseControl(this.angleMeasurements)
        this.angleMeasurementsMouseControl.snapping = true;
      },
      toogleMeasurementAngleTool() {
        this.closeOtherTools('angle')
        if (this.angleMeasurementsMouseControl) {
          if (this.angleMeasurementsMouseControl.active) {
            this.angleMeasurementsMouseControl.deactivate();
            this.tools.angleMeasurementToolActive = false;
          } else {
            this.angleMeasurementsMouseControl.activate();
            this.tools.angleMeasurementToolActive = true;
          }
        }
      },

      createMeasurementDistanceTool() {
        this.distanceMeasurements = new DistanceMeasurementsPlugin(this.viewer);
        this.distanceMeasurementsMouseControl = new DistanceMeasurementsMouseControl(this.distanceMeasurements)
        this.distanceMeasurementsMouseControl.snapping = true;
      },
      toogleMeasurementDistanceTool() {
        this.closeOtherTools('distance')
        if (this.distanceMeasurementsMouseControl) {
          if (this.distanceMeasurementsMouseControl.active) {
            this.distanceMeasurementsMouseControl.deactivate();
            this.tools.distanceMeasurementToolActive = false;
          } else {
            this.distanceMeasurementsMouseControl.activate();
            this.tools.distanceMeasurementToolActive = true;
          }
        }
      },

      createSelectObjectTool() {
        const existingClickHandler = this.viewer.scene.canvas.canvas._clickHandler;
        if (existingClickHandler) {
          this.viewer.scene.canvas.canvas.removeEventListener('click', existingClickHandler);
        }

        const clickHandler = (event) => {
          if (!this.tools.selectObjectActive) return
          const canvasPos = this.getCanvasPosFromEvent(event);
          const hit = this.viewer.scene.pick({
            canvasPos
          });
          if (hit && hit.entity.isObject) {
            let selected = !hit.entity.selected
            this.viewer.scene.setObjectsSelected(hit.entity.id, selected);
          }
          event.preventDefault();
        };

        this.viewer.scene.canvas.canvas._clickHandler = clickHandler;
        this.viewer.scene.canvas.canvas.addEventListener('click', clickHandler);
      },

      toogleSelectObjectTool() {
        this.closeOtherTools('select')
        this.tools.selectObjectActive = !this.tools.selectObjectActive
      },

      createHideObjectTool() {
        const existingClickHideHandler = this.viewer.scene.canvas.canvas._clickHideHandler;
        if (existingClickHideHandler) {
          this.viewer.scene.canvas.canvas.removeEventListener('click', existingClickHideHandler);
        }

        const clickHideHandler = (event) => {
          if (!this.tools.hideObjectActive) return
          const canvasPos = this.getCanvasPosFromEvent(event);
          const hit = this.viewer.scene.pick({
            canvasPos
          });
          if (hit && hit.entity.isObject) {
            hit.entity.visible = false
          }
          event.preventDefault();
        };

        this.viewer.scene.canvas.canvas._clickHideHandler = clickHideHandler;
        this.viewer.scene.canvas.canvas.addEventListener('click', clickHideHandler);
      },

      toogleHideObjectTool() {
        this.closeOtherTools('hide')
        this.tools.hideObjectActive = !this.tools.hideObjectActive
      },

      createSectionPlanesTool() {
        const sectionPlanes = new SectionPlanesPlugin(this.viewer, {});

        this.viewer.scene.input.on("mouseclicked", (coords) => {
          if (!this.tools.sectionPlanesActive) return

          var pickResult = this.viewer.scene.pick({
            canvasPos: coords,
            pickSurface: true
          });

          if (pickResult && pickResult.worldNormal) {

            if (pickResult.entity) {
              if (!pickResult.entity.isObject) {
                return;
              }
            }

            sectionPlanes.clear()

            const sectionPlane = sectionPlanes.createSectionPlane({
              pos: pickResult.worldPos,
              dir: math.mulVec3Scalar(pickResult.worldNormal, -1)
            });

            sectionPlanes.showControl(sectionPlane.id);
          }
        });
      },

      toogleSectionPlanesTool() {
        this.closeOtherTools('section')
        this.tools.sectionPlanesActive = !this.tools.sectionPlanesActive
      },

      toogleCameraOrtho() {
        this.tools.cameraOrthoActive = !this.tools.cameraOrthoActive
        if (this.tools.view2DActive) this._exitView2D();
        this.tools.view2DActive = false;
        this.viewer.cameraFlight.flyTo({
          projection: this.tools.cameraOrthoActive ? "ortho" : "perspective"
        });
      },

      goTopView2D() {
        if (!this.viewer) return;
        const aabb = this._getView2DAABB();
        if (!aabb) return;

        if (this.progressColorFilter) this.clearColorFilter();

        this._snapshotSceneState();
        this._applyBlueprintScene();
        this._applyProgressColorize();
        this._applyTopDownCamera(aabb);

        this.tools.cameraOrthoActive = true;
        this.tools.view2DActive = true;
        this.viewer.cameraControl.navMode = 'planView';

        this._createBlueprintPOIs(ELECTRICAL_IFC_TYPES);
      },

      _getView2DAABB() {
        const first = this.sceneModels[0]?.aabb;
        if (first && first.length === 6) return first;
        const full = this.viewer.scene.getAABB();
        return (full && full.length === 6) ? full : null;
      },

      _snapshotSceneState() {
        if (this._view2DSnapshot) return;
        const scene = this.viewer.scene;
        this._view2DSnapshot = {
          bg: [...scene.canvas.backgroundColor],
          edgesEnabled: scene.edgesEnabled,
          edgeColor: [...scene.edgeMaterial.edgeColor],
          edgeAlpha: scene.edgeMaterial.edgeAlpha,
          edgeWidth: scene.edgeMaterial.edgeWidth,
          sao: scene.sao.enabled,
          pbr: scene.pbrEnabled,
          colorTexture: scene.colorTextureEnabled,
          navMode: this.viewer.cameraControl.navMode,
          colorizedIds: [],
        };
      },

      _applyBlueprintScene() {
        const scene = this.viewer.scene;
        scene.canvas.backgroundColor = BLUEPRINT_BG_RGB;
        scene.sao.enabled = false;
        scene.pbrEnabled = false;
        scene.colorTextureEnabled = false;
        scene.edgesEnabled = true;
        scene.edgeMaterial.edgeColor = BLUEPRINT_EDGE_RGB;
        scene.edgeMaterial.edgeAlpha = BLUEPRINT_EDGE_ALPHA;
        scene.edgeMaterial.edgeWidth = BLUEPRINT_EDGE_WIDTH;
      },

      _applyProgressColorize() {
        const scene = this.viewer.scene;
        const metaObjects = this.viewer.metaScene?.metaObjects || {};
        const colorizedIds = this._view2DSnapshot.colorizedIds = [];
        const taken = new Set();

        for (const [id, prog] of Object.entries(this.elementProgressMap)) {
          if (!prog?.color) continue;
          const entity = scene.objects[id];
          if (!entity) continue;
          const rgb = this._hexToRgb01(prog.color);
          if (!rgb) continue;
          entity.colorize = rgb;
          colorizedIds.push(id);
          taken.add(id);
        }

        for (const id in metaObjects) {
          if (taken.has(id)) continue;
          if (!ELECTRICAL_IFC_TYPES.has(metaObjects[id]?.type)) continue;
          const entity = scene.objects[id];
          if (!entity) continue;
          entity.colorize = ELECTRICAL_HIGHLIGHT_RGB;
          colorizedIds.push(id);
        }
      },

      _applyTopDownCamera(aabb) {
        const scene = this.viewer.scene;
        const cx = (aabb[0] + aabb[3]) / 2;
        const cy = (aabb[1] + aabb[4]) / 2;
        const cz = (aabb[2] + aabb[5]) / 2;
        const sizeX = Math.max(aabb[3] - aabb[0], 1);
        const sizeY = Math.max(aabb[4] - aabb[1], 1);
        const sizeZ = Math.max(aabb[5] - aabb[2], 1);

        const canvasEl = scene.canvas?.canvas;
        const canvasW = canvasEl?.clientWidth || 1;
        const canvasH = canvasEl?.clientHeight || 1;
        const aspect = canvasW / canvasH;

        scene.camera.projection = 'ortho';
        scene.camera.up   = [0, 0, -1];
        scene.camera.eye  = [cx, aabb[4] + sizeY * 2 + 10, cz];
        scene.camera.look = [cx, cy, cz];

        const fitScale = (canvasW >= canvasH)
          ? Math.max(sizeX, sizeZ * aspect)
          : Math.max(sizeX / aspect, sizeZ);
        scene.camera.ortho.scale = fitScale * 1.2;
      },

      _exitView2D() {
        const snap = this._view2DSnapshot;
        if (!snap || !this.viewer) return;
        this._restoreSceneState(snap);
        this._clearProgressColorize(snap);
        this._view2DSnapshot = null;
        this._destroyProgressAnnotations();
      },

      _restoreSceneState(snap) {
        const scene = this.viewer.scene;
        scene.canvas.backgroundColor = snap.bg;
        scene.edgesEnabled = snap.edgesEnabled;
        scene.edgeMaterial.edgeColor = snap.edgeColor;
        scene.edgeMaterial.edgeAlpha = snap.edgeAlpha;
        scene.edgeMaterial.edgeWidth = snap.edgeWidth;
        scene.sao.enabled = snap.sao;
        scene.pbrEnabled = snap.pbr;
        scene.colorTextureEnabled = snap.colorTexture;
        if (snap.navMode) this.viewer.cameraControl.navMode = snap.navMode;
      },

      _clearProgressColorize(snap) {
        const scene = this.viewer.scene;
        for (const id of snap.colorizedIds) {
          const e = scene.objects[id];
          if (e) e.colorize = [1, 1, 1];
        }
      },

      _createBlueprintPOIs(typeSet) {
        if (!this.viewer) return;
        const scene = this.viewer.scene;
        const canvas = scene.canvas.canvas;
        const container = canvas.parentElement;
        if (!container) return;

        this._destroyProgressAnnotations();

        if (!this._annotationsOverlay) {
          const overlay = document.createElement('div');
          overlay.className = 'bim-annot-overlay';
          container.appendChild(overlay);
          this._annotationsOverlay = overlay;
        }
        this._annotations = [];

        const metaObjects = this.viewer.metaScene?.metaObjects || {};
        for (const id of scene.objectIds) {
          if (!typeSet.has(metaObjects[id]?.type)) continue;
          const entity = scene.objects[id];
          if (!entity?.aabb) continue;

          const prog = this.elementProgressMap[id];
          const color = prog?.color || '#4adfff';
          const name = metaObjects[id]?.name || '';
          const kpi = (prog?.percentage != null)
            ? `<span class="bim-poi-kpi" style="background:${color}">${prog.percentage}%</span>`
            : '';

          const el = document.createElement('div');
          el.className = 'bim-poi-marker';
          el.style.setProperty('--poi-color', color);
          el.innerHTML = `
            <span class="bim-poi-dot"></span>
            <span class="bim-poi-label">${name}</span>
            ${kpi}
          `;
          this._annotationsOverlay.appendChild(el);
          this._annotations.push({ el, entity });
        }

        if (!this._annotationTickHandle && scene) {
          this._annotationTickHandle = scene.on('tick', () => this._updateAnnotationPositions());
        }
        this._updateAnnotationPositions();
      },

      closeOtherTools(current) {
        if (this.tools.angleMeasurementToolActive && current != 'angle') {
          this.toogleMeasurementAngleTool()
        }
        if (this.tools.distanceMeasurementToolActive && current != 'distance') {
          this.toogleMeasurementDistanceTool()
        }
        if (this.tools.sectionPlanesActive && current != 'section') {
          this.toogleSectionPlanesTool()
        }
        if (this.tools.selectObjectActive && current != 'select') {
          this.toogleSelectObjectTool()
        }
        if (this.tools.hideObjectActive && current != 'hide') {
          this.toogleHideObjectTool()
        }
      },

      // Carga las propiedades del metaObject en el panel de propiedades.
      // No resetea showMetaObjectProps para persistir las decisiones del usuario
      // entre selecciones (si abrió Pset_Common en una pared, lo verá abierto
      // en la siguiente pared sin tener que volver a hacer clic).
      _loadElementProperties(objectId) {
        const metaObject = this.viewer?.metaScene?.metaObjects[objectId] || null;

        // Atributos y Avance abiertos la primera vez; propertysets colapsados
        // por defecto para no inflar el panel.
        if (this.showMetaObjectProps.basic === undefined) {
          this.$set(this.showMetaObjectProps, 'basic', true);
        }
        if (this.showMetaObjectProps._avance === undefined) {
          this.$set(this.showMetaObjectProps, '_avance', true);
        }

        if (metaObject) {
          this.currentMetaObjectData = {
            id: metaObject.id,
            name: metaObject.name,
            type: metaObject.type,
            propertySets: metaObject.propertySets ? metaObject.propertySets.map(p => ({
              name: p.name,
              properties: p.properties ? p.properties.map(pp => ({
                name: pp.name,
                value: pp.value
              })) : []
            })) : []
          };
        } else {
          this.currentMetaObjectData = {
            id: objectId,
            name: objectId,
            type: '-',
            propertySets: []
          };
        }

        this.leftMenu.properties = true;
      },

      // Filtro DOM-based del árbol: oculta los <li> que no matchean y muestra
      // sus ancestros para mantener la jerarquía visible. Sin query, restaura.
      _filterTree() {
        const container = document.getElementById("treeViewContainer");
        if (!container) return;
        const q = (this.treeSearchQuery || '').toLowerCase().trim();
        const lis = container.querySelectorAll('li');

        if (!q) {
          lis.forEach(li => { li.style.display = ''; });
          return;
        }

        lis.forEach(li => { li.style.display = 'none'; });
        lis.forEach(li => {
          const span = li.querySelector(':scope > span');
          if (!span) return;
          if (span.textContent.toLowerCase().includes(q)) {
            let cur = li;
            while (cur && cur.tagName === 'LI') {
              cur.style.display = '';
              cur = cur.parentElement?.closest('li');
            }
          }
        });
      },

      _syncSelectionToTree(objectId) {
        if (!objectId || !this.viewer) return;

        if (!this.tools.treeViewActive) {
          this.tools.treeViewActive = true;
        }
        this.leftMenu.tree = true;

        if (this.treeViewDirty && !this.isBuildingTree) {
          this._pendingTreeSync = objectId;
          this.isBuildingTree = true;
          requestAnimationFrame(() => {
            setTimeout(() => {
              this.createTreeView();
              this.treeViewDirty = false;
              this.isBuildingTree = false;
              if (this._pendingTreeSync) {
                this._showAndHighlightNode(this._pendingTreeSync);
                this._pendingTreeSync = null;
              }
            }, 300);
          });
          return;
        }

        // Si el árbol se está construyendo, guardar para después
        if (this.isBuildingTree) {
          this._pendingTreeSync = objectId;
          return;
        }

        this._showAndHighlightNode(objectId);
      },

      _showAndHighlightNode(objectId) {
        if (!this.treeView) return;
        this.treeView.showNode(objectId);
        this.$nextTick(() => this._highlightTreeSpan(objectId));
      },

      // Busca el <li> del árbol cuyo id termine con `-${objectId}`. null si no.
      _findTreeLi(container, objectId) {
        if (!container || !objectId) return null;
        const allLis = container.querySelectorAll('li');
        for (const li of allLis) {
          if (li.id && li.id.endsWith('-' + objectId)) return li;
        }
        return null;
      },

      _highlightTreeSpan(objectId) {
        const container = document.getElementById("treeViewContainer");
        if (!container) return;

        // Limpiar highlights previos
        container.querySelectorAll('.bim-tree-selected').forEach(el => {
          el.classList.remove('bim-tree-selected');
        });

        let li = this._findTreeLi(container, objectId);

        if (!li && this.viewer?.metaScene?.metaObjects) {
          let mo = this.viewer.metaScene.metaObjects[objectId];
          let parent = mo?.parent;
          while (parent && !li) {
            li = this._findTreeLi(container, parent.id);
            parent = parent.parent;
          }
        }

        if (li) {
            let cursor = li.parentElement?.closest('li');
            while (cursor) {
              const toggle = cursor.querySelector(':scope > a');
              if (toggle && toggle.classList.contains('plus')) {
                toggle.click();
              }
              cursor = cursor.parentElement?.closest('li');
            }

            const span = li.querySelector(':scope > span');
            if (span) {
              span.classList.add('bim-tree-selected');
              span.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
        }
      },

      cancelLoading() {
        this.loadingCancelled = true;
      },

      async handleFileUploads(urlArray) {
        if (!urlArray || urlArray.length === 0) return;

        // Siempre destruir y recrear el viewer para evitar bugs de xeokit
        // donde model.destroy() deja layers huérfanas en el render loop
        if (this.viewerReady) {
          this._loadGeneration++;
          // Preservar cache de buffers XKT descargados
          const savedCache = this.xktBufferCache;
          this.destroyAll();
          this.xktBufferCache = savedCache;
        }
        await this.initViewer();

        // initViewer puede salir temprano si el canvas aún no estaba en el DOM.
        // Sin este guard, el spinner.processes++ revienta y deja el componente
        // a medias entre dos cargas de IFC.
        if (!this.viewer) {
          console.warn('[BimViewer] initViewer no creó el Viewer; abortando carga');
          return;
        }

        const validUrls = urlArray.filter(Boolean);
        if (validUrls.length === 0) return;

        const generation = this._loadGeneration;
        const total = validUrls.length;
        this.loadingCancelled = false;
        this.loadingProgress = { loaded: 0, total, current: '', downloadPct: 0 };
        this.viewer.scene.canvas.spinner.processes++;

        const MAX_CONCURRENT = 1;

        const bufferResolvers = {};
        const bufferPromises = validUrls.map((url, i) => {
          if (this.xktBufferCache[url]) {
            return Promise.resolve(this.xktBufferCache[url]);
          }
          return new Promise(resolve => { bufferResolvers[i] = resolve; });
        });

        const uncachedIndices = validUrls
          .map((url, i) => (this.xktBufferCache[url] ? null : i))
          .filter(i => i !== null);

        let dlCursor = 0;
        let activeDownloads = 0;
        const launchDownloads = () => {
          while (activeDownloads < MAX_CONCURRENT && dlCursor < uncachedIndices.length) {
            const idx = uncachedIndices[dlCursor++];
            activeDownloads++;
            const reportProgress = (total === 1) || (idx === 0);
            this._downloadXkt(validUrls[idx], reportProgress).then(buffer => {
              activeDownloads--;
              if (buffer && buffer.byteLength <= this.xktCacheMaxBytes) {
                this.xktBufferCache[validUrls[idx]] = buffer;
              }
              bufferResolvers[idx](buffer);
              launchDownloads();
            });
          }
        };
        launchDownloads();

        // Edificios distintos: variables para colocar modelos lado a lado
        const isSideBySide = !this.federated && total > 1;
        let sideBySideNextX = 0;
        const SIDE_GAP = 15; // metros de separación entre edificios

        for (let i = 0; i < total; i++) {
          // Abortar si se inició una nueva carga
          if (generation !== this._loadGeneration || this.loadingCancelled) {
            this.loadingProgress.loaded = total;
            break;
          }

          const buffer = await bufferPromises[i];

          if (!buffer) {
            this.loadingProgress.loaded++;
            continue;
          }

          // Verificar de nuevo después del await
          if (generation !== this._loadGeneration) break;

          const sizeMb = buffer.byteLength / (1024 * 1024);
          this.loadingProgress.current = `${sizeMb.toFixed(1)} MB`;

          await new Promise(r => requestAnimationFrame(r));

          if (generation !== this._loadGeneration || this.loadingCancelled) {
            this.loadingProgress.loaded = total;
            break;
          }

          try {
            const isHuge = sizeMb > 40;

            const model = this.loader.load({
              id: `model-g${generation}-${i}`,
              xkt: buffer,
              loadMetadata: !isHuge,
              edges: false,
              saoEnabled: false,
              pbrEnabled: false,
              dtxEnabled: true,
              backfaces: false,
              ignoreGeometryErrors: true,
            });
            // URL recordada para diagnóstico/logs (_destroyCatastrophicModels).
            model._sourceUrl = validUrls[i];
            this.sceneModels.push(model);

            // Parche: xeokit crashea si un layer es undefined en _withEachVisibleLayer.
            // Se parchea el prototipo una sola vez para saltar layers corruptos.
            if (!this._xeokitLayerPatched) {
              const proto = Object.getPrototypeOf(model);
              if (proto && proto._withEachVisibleLayer) {
                proto._withEachVisibleLayer = function (testNumVisibleLayerPortions, cb) {
                  if (testNumVisibleLayerPortions && (this.numVisibleLayerPortions === 0)) return;
                  const renderFlags = this.renderFlags;
                  for (let i = 0, len = renderFlags.visibleLayers.length; i < len; i++) {
                    const layerIndex = renderFlags.visibleLayers[i];
                    const layer = this.layerList[layerIndex];
                    if (layer) cb(layer);
                  }
                };
                this._xeokitLayerPatched = true;
              }
            }

            const loadTimeout = sizeMb > 100 ? 300000 : sizeMb > 30 ? 120000 : sizeMb > 10 ? 60000 : 30000;

            let done = false;
            await Promise.race([
              new Promise(resolve => {
                const finish = () => {
                  if (done) return;
                  done = true;
                  this.loadingProgress.loaded++;

                  // Enfocar el primer modelo cargado para dar feedback visual
                  // mientras siguen llegando los demás.
                  if (i === 0 && this.viewer) {
                    this.viewer.cameraFlight.flyTo({
                      aabb: model.aabb,
                      duration: 0.5,
                      fitFOV: 45
                    });
                  }

                  // Edificios distintos: reposicionar cada modelo lado a lado
                  if (isSideBySide && model.aabb) {
                    const aabb = model.aabb; // [xmin, ymin, zmin, xmax, ymax, zmax]
                    const cx = (aabb[0] + aabb[3]) / 2;
                    const cz = (aabb[2] + aabb[5]) / 2;
                    const halfWidth = (aabb[3] - aabb[0]) / 2;

                    // Coloca el modelo: centrado en Z, alineado en X al lado del anterior
                    model.position = [sideBySideNextX + halfWidth - cx, 0, -cz];
                    sideBySideNextX += (aabb[3] - aabb[0]) + SIDE_GAP;
                  }

                  resolve();
                };
                model.on?.('loaded', finish);
                model.on?.('error', finish);
                if (model.loaded) finish();
              }),
              new Promise(r => setTimeout(() => {
                if (!done) { done = true; this.loadingProgress.loaded++; }
                r();
              }, loadTimeout))
            ]);
          } catch (_) {
            this.loadingProgress.loaded++;
          }

          this.loadingProgress.current = '';
          this.loadingProgress.downloadPct = 0;

          if (sizeMb > 30) {
            await new Promise(r => setTimeout(r, 200));
          } else if (sizeMb > 10) {
            await new Promise(r => setTimeout(r, 100));
          }
        }

        if (this.viewer) this.viewer.scene.canvas.spinner.processes--;

        // Si esta generación fue invalidada, no actualizar UI
        if (generation !== this._loadGeneration) return;

        // Enfocar la cámara al finalizar la carga
        if (this.viewer && this.sceneModels.length > 0) {
          // Federado (superpuesto): usar AABB del primer modelo para evitar
          // que geometría lejana del último modelo arrastre la cámara
          // Side-by-side: usar AABB completa de la escena para ver todos
          const aabb = (isSideBySide && this.sceneModels.length > 1)
            ? this.viewer.scene.getAABB()
            : this.sceneModels[0].aabb;
          this.viewer.cameraFlight.flyTo({
            aabb: aabb,
            duration: 1.0,
            fitFOV: 45
          });
        }

        if (this.tools.treeViewActive) {
          this.createTreeView();
        } else {
          this.treeViewDirty = true;
        }

        this._destroyCatastrophicModels();

        // Precarga de avance desde los propertysets embebidos en el IFC/XKT
        this._loadProgressFromMeta();

        // Finaliza la barra de carga tras completarse
        setTimeout(() => { this.loadingProgress = { loaded: 0, total: 0, current: '', downloadPct: 0 }; }, 2000);
      },
     
      _destroyCatastrophicModels() {
        const survivors = [];
        const killed = [];
        for (const m of this.sceneModels) {
          const a = m.aabb;
          const valid = a && a.length === 6;
          const dx = valid ? (a[3] - a[0]) : 0;
          const dz = valid ? (a[5] - a[2]) : 0;
          if (dx > 10000 || dz > 10000) {
            killed.push({ id: m.id, url: m._sourceUrl, dx: +dx.toFixed(0), dz: +dz.toFixed(0) });
            try { m.destroy(); } catch (_) {}
          } else {
            survivors.push(m);
          }
        }
        this.sceneModels = survivors;
        if (killed.length > 0) {
          console.warn(`[BimViewer] ${killed.length} IFC(s) descartado(s) por AABB catastrófico (geometría parásita):`, killed);
        }
      },

      async _downloadXkt(url, reportProgress = false) {
        try {
          const controller = new AbortController();
          const t = setTimeout(() => controller.abort(), 300000);
          const resp = await fetch(url, { signal: controller.signal });
          clearTimeout(t);
          if (!resp.ok) return null;

          const contentLength = parseInt(resp.headers.get('Content-Length') || '0', 10);

          if (!contentLength || contentLength < 20 * 1024 * 1024) {
            if (reportProgress) this.loadingProgress.downloadPct = 0;
            const buffer = await resp.arrayBuffer();
            if (reportProgress) this.loadingProgress.downloadPct = 100;
            return buffer;
          }

          const reader = resp.body.getReader();
          const chunks = [];
          let received = 0;

          while (true) {
            if (this.loadingCancelled) {
              reader.cancel();
              return null;
            }

            const { done, value } = await reader.read();
            if (done) break;

            chunks.push(value);
            received += value.length;

            if (reportProgress && contentLength > 0) {
              this.loadingProgress.downloadPct = Math.round((received / contentLength) * 100);
            }
          }

          const buffer = new Uint8Array(received);
          let offset = 0;
          for (const chunk of chunks) {
            buffer.set(chunk, offset);
            offset += chunk.length;
          }

          if (reportProgress) this.loadingProgress.downloadPct = 100;
          return buffer.buffer;
        } catch (_) { }
        return null;
      },

      resetAll() {
        if (this.sceneModels.length > 0 && this.viewer) {
          const scene = this.viewer.scene;
          scene.setObjectsVisible(scene.objectIds, true);
          scene.setObjectsXRayed(scene.xrayedObjectIds, false);
          scene.setObjectsSelected(scene.selectedObjectIds, false);
          scene.setObjectsHighlighted(scene.highlightedObjectIds, false);
          if (this.angleMeasurements) this.angleMeasurements.clear();
          if (this.distanceMeasurements) this.distanceMeasurements.clear();
          this.bimPopup.visible = false;
          // Volver al estado inicial implica salir de la vista 2D.
          if (this.tools.view2DActive) this._exitView2D();
          this.tools.view2DActive = false;

          this.viewer.cameraFlight.flyTo({
            projection: this.tools.cameraOrthoActive ? 'ortho' : 'perspective',
            aabb: this.sceneModels[0].aabb,
            duration: 0.5
          });
        } else {
          this.handleFileUploads(this.effectiveUrls);
        }
      },

      destroyAll() {
        // Forzar a Vue a recrear el <canvas> en la próxima render. Resuelve el
        // bug en el que xeokit deja el WebGL context perdido y el siguiente
        // `new Viewer({canvasId: "myCanvas"})` falla con "Mandatory config…".
        this.canvasKey++;

        this.sceneModels.forEach(model => {
          try { model.destroy(); } catch (e) { }
        });
        this.sceneModels = [];
        if (this.treeView) {
          try { this.treeView.destroy(); } catch (e) { }
          this.treeView = null;
        }
        if (this.treeViewContextMenu) {
          try { this.treeViewContextMenu.destroy(); } catch (e) { }
          this.treeViewContextMenu = null;
        }
        if (this.angleMeasurements) {
          try { this.angleMeasurements.destroy(); } catch (e) { }
          this.angleMeasurements = null;
        }
        if (this.distanceMeasurements) {
          try { this.distanceMeasurements.destroy(); } catch (e) { }
          this.distanceMeasurements = null;
        }
        this._destroyProgressAnnotations();
        if (this._annotationsOverlay && this._annotationsOverlay.parentElement) {
          this._annotationsOverlay.parentElement.removeChild(this._annotationsOverlay);
          this._annotationsOverlay = null;
        }
        if (this.loader) {
          try { this.loader.destroy(); } catch (e) { }
          this.loader = null;
        }
        if (this.viewer) {
          try { this.viewer.destroy(); } catch (e) { }
          this.viewer = null;
        }
        this.viewerReady = false;
        this.currentMetaObjectData = null;
        this.showMetaObjectProps = {};
        this.bimPopup.visible = false;
        this.xktBufferCache = {};
      },

      setCurrentProgress(field, value) {
        const id = this.currentMetaObjectData?.id;
        if (!id) return;
        const current = this.elementProgressMap[id] || { percentage: null, color: null };
        const next = { ...current, [field]: value === '' ? null : value };
        // Si el usuario elige un color sin haber tocado el porcentaje, damos un
        // default coherente con el estado: "Sin iniciar"=0, "Completado"=100.
        if (field === 'color' && (current.percentage === null || current.percentage === undefined)) {
          if (value === '#9e9e9e') next.percentage = 0;
          else if (value === '#4caf50') next.percentage = 100;
          else next.percentage = 0;
        }
        this._upsertProgress(id, next);
        if (this.progressColorFilter) this._applyColorFilter(this.progressColorFilter);
      },

      // Convierte "#rrggbb" a [r, g, b] 0-1 (formato que espera xeokit).
      _hexToRgb01(hex) {
        const h = String(hex || '').replace('#', '');
        if (h.length !== 6) return null;
        return [
          parseInt(h.substr(0, 2), 16) / 255,
          parseInt(h.substr(2, 2), 16) / 255,
          parseInt(h.substr(4, 2), 16) / 255,
        ];
      },

      toggleColorFilter(color) {
        if (this.progressColorFilter === color) {
          this.clearColorFilter();
        } else {
          this.progressColorFilter = color;
          this._applyColorFilter(color);
        }
      },

      // Pinta solo los elementos del color del filtro y deja al resto como
      // "ghost" gris claro opaco. Para no lavar los colores nativos del IFC,
      // SOLO tocamos `colorize` en las entidades que pintamos: las demás
      // mantienen su shader/material original tal cual lo cargó el XKT.
      _applyColorFilter(color) {
        if (!this.viewer) return;
        const scene = this.viewer.scene;
        const rgb = this._hexToRgb01(color);
        const matching = [];
        const others = [];
        for (const id of scene.objectIds) {
          const prog = this.elementProgressMap[id];
          if (prog && prog.color === color) matching.push(id);
          else others.push(id);
        }

        // Devuelve a su color original las que estaban pintadas en un filtro
        // anterior y ya no aplican.
        const matchingSet = new Set(matching);
        for (const id of (this._filterColorizedIds || [])) {
          if (matchingSet.has(id)) continue;
          const entity = scene.objects[id];
          if (entity) entity.colorize = [1, 1, 1];
        }
        this._filterColorizedIds = [];

        if (rgb) {
          for (const id of matching) {
            const entity = scene.objects[id];
            if (entity) entity.colorize = rgb;
            this._filterColorizedIds.push(id);
          }
        }

        this._setNeutralXrayMaterial(true);
        scene.setObjectsXRayed(others, true);
        scene.setObjectsXRayed(matching, false);

        this._destroyProgressAnnotations();
        this._createProgressAnnotations(matching);
      },

      // Restaura el estado original tal cual se cargó el IFC:
      // - quita colorize SOLO en las entidades que pintamos
      // - quita x-ray en las que xrayamos
      // - vuelve xrayMaterial al fade oscuro original
      clearColorFilter() {
        this.progressColorFilter = null;
        if (!this.viewer) return;
        const scene = this.viewer.scene;

        for (const id of (this._filterColorizedIds || [])) {
          const entity = scene.objects[id];
          if (entity) entity.colorize = [1, 1, 1];
        }
        this._filterColorizedIds = [];

        this._setNeutralXrayMaterial(false);
        if (scene.numXRayedObjects > 0) {
          scene.setObjectsXRayed(scene.xrayedObjectIds, false);
        }
        this._destroyProgressAnnotations();
      },

      // Cambia el aspecto del xrayMaterial entre el "fade" oscuro original y un
      // gris claro opaco que cubre los colores nativos del IFC durante el filtro.
      _setNeutralXrayMaterial(neutral) {
        if (!this.viewer) return;
        const m = this.viewer.scene.xrayMaterial;
        if (!m) return;
        m.fill = true;
        m.edges = false;
        if (neutral) {
          m.fillColor = [0.85, 0.85, 0.85];
          m.fillAlpha = 0.95;
        } else {
          m.fillColor = [0, 0, 0];
          m.fillAlpha = 0.1;
        }
      },

      // Crea una etiqueta flotante HTML sobre cada elemento filtrado con su %.
      // Usamos overlay manual en vez de AnnotationsPlugin porque este último mete
      // los markers fuera del canvas y el CSS queda inconsistente.
      _createProgressAnnotations(ids) {
        if (!this.viewer) return;
        const canvas = this.viewer.scene.canvas.canvas;
        const container = canvas.parentElement;
        if (!container) return;

        if (!this._annotationsOverlay) {
          const overlay = document.createElement('div');
          overlay.className = 'bim-annot-overlay';
          container.appendChild(overlay);
          this._annotationsOverlay = overlay;
        }

        this._annotations = [];
        const scene = this.viewer.scene;
        for (const id of ids) {
          const entity = scene.objects[id];
          const data = this.elementProgressMap[id];
          if (!entity?.aabb || !data) continue;
          const aabb = entity.aabb;
          if (
            aabb[0] > aabb[3] || aabb[1] > aabb[4] || aabb[2] > aabb[5]
          ) continue;
          const worldPos = [
            (aabb[0] + aabb[3]) / 2,
            (aabb[1] + aabb[4]) / 2,
            (aabb[2] + aabb[5]) / 2,
          ];

          const el = document.createElement('div');
          el.className = 'bim-annot-marker';
          el.style.background = data.color || '#9e9e9e';
          el.textContent = `${data.percentage ?? 0}%`;
          this._annotationsOverlay.appendChild(el);

          this._annotations.push({ el, entity, worldPos });
        }

        if (!this._annotationTickHandle && this.viewer.scene) {
          this._annotationTickHandle = this.viewer.scene.on('tick', () => this._updateAnnotationPositions());
        }
        this._updateAnnotationPositions();
      },

      _updateAnnotationPositions() {
        if (!this.viewer || !this._annotations) return;
        const scene = this.viewer.scene;
        const canvas = scene.canvas.canvas;
        const w = canvas.clientWidth;
        const h = canvas.clientHeight;

        if (!this._posIn)   this._posIn   = math.vec4();
        if (!this._posView) this._posView = math.vec4();
        if (!this._posProj) this._posProj = math.vec4();

        for (const ann of this._annotations) {
          const { el, entity } = ann;
          // Recalcula cada frame desde el AABB actual del entity.
          const aabb = entity?.aabb;
          if (!aabb) { el.style.display = 'none'; continue; }
          this._posIn[0] = (aabb[0] + aabb[3]) / 2;
          this._posIn[1] = (aabb[1] + aabb[4]) / 2;
          this._posIn[2] = (aabb[2] + aabb[5]) / 2;
          this._posIn[3] = 1;
          math.transformPoint4(scene.camera.viewMatrix, this._posIn, this._posView);
          math.transformPoint4(scene.camera.projMatrix, this._posView, this._posProj);

          if (this._posView[2] >= 0 || this._posProj[3] <= 0) {
            el.style.display = 'none';
            continue;
          }
          const ndcX = this._posProj[0] / this._posProj[3];
          const ndcY = this._posProj[1] / this._posProj[3];
          const x = (ndcX * 0.5 + 0.5) * w;
          const y = (0.5 - ndcY * 0.5) * h;
          el.style.display = 'inline-block';
          el.style.left = `${x}px`;
          el.style.top = `${y}px`;
        }
      },

      _destroyProgressAnnotations() {
        if (this._annotationTickHandle !== undefined && this.viewer?.scene) {
          try { this.viewer.scene.off(this._annotationTickHandle); } catch (_) {}
          this._annotationTickHandle = undefined;
        }
        if (this._annotationsOverlay) this._annotationsOverlay.innerHTML = '';
        this._annotations = [];
      },

      // Inserta/actualiza el avance del elemento. Si el resultado equivale a "sin avance"
      _upsertProgress(id, data) {
        const pct = (data.percentage === null || data.percentage === undefined || data.percentage === '')
          ? null
          : Number(data.percentage);
        const isEmpty = (!pct) && !data.color;
        if (isEmpty) {
          if (this.elementProgressMap[id]) this.$delete(this.elementProgressMap, id);
        } else {
          this.$set(this.elementProgressMap, id, { percentage: pct, color: data.color || null });
        }
        // En ambos casos (edición o borrado) es un cambio del usuario.
        this.$set(this.dirtyElementIds, id, true);
      },

      // Solo descarta los dirty, respeta el avance ya incrustado en el IFC.
      discardPendingProgress() {
        for (const id of Object.keys(this.dirtyElementIds)) {
          if (this.elementProgressMap[id]) this.$delete(this.elementProgressMap, id);
        }
        this.dirtyElementIds = {};
        this._loadProgressFromMeta();
      },

      // Resuelve a qué documentId pertenece un globalId en federado (o individual).
      // Intenta 3 vías: entity.model.id, metaObject.metaModels, metaObject.metaModel.
      _docIdForGlobalId(globalId) {
        if (!Array.isArray(this.documentIds) || this.documentIds.length === 0) {
          return this.documentId || null;
        }

        let modelId = null;
        const scene = this.viewer?.scene;
        const metaScene = this.viewer?.metaScene;

        modelId = scene?.objects?.[globalId]?.model?.id || null;

        // Xeokit 2.x expone metaModels como array, o metaModel.
        if (!modelId && metaScene?.metaObjects?.[globalId]) {
          const mo = metaScene.metaObjects[globalId];
          if (Array.isArray(mo.metaModels) && mo.metaModels.length > 0) {
            modelId = mo.metaModels[0].id;
          } else if (mo.metaModel?.id) {
            modelId = mo.metaModel.id;
          }
        }

        if (modelId) {
          const match = String(modelId).match(/-(\d+)$/);
          const idx = match ? parseInt(match[1], 10) : -1;
          if (idx >= 0 && idx < this.documentIds.length) return this.documentIds[idx];
        }
        return null;
      },

      // Envía los avances SOLO a los IFCs donde el usuario ha hecho cambios
      // (dirty). En un federado de 29 IFCs si solo tocas 1 elemento, solo se
      // regenera 1 _avance.ifc + XKT. Al doc que sí tocamos le mandamos su
      // estado COMPLETO (precarga + ediciones) para no perder avance previo.
      async embedAllProgress() {
        if (this.progressSyncState === 'saving') return;
        const targets = this.embedTargetIds;
        if (targets.length === 0) return;
        if (Object.keys(this.dirtyElementIds).length === 0) return;

        //    Qué documentos tienen al menos un cambio dirty.
        //    Si un dirty no mapea a ningún doc (caso raro), lo tratamos como
        //    si afectara a TODOS los targets para no perderlo.
        const dirtyDocIds = new Set();
        const unmappedDirty = [];
        for (const globalId of Object.keys(this.dirtyElementIds)) {
          const docId = this._docIdForGlobalId(globalId);
          if (docId) dirtyDocIds.add(docId);
          else unmappedDirty.push(globalId);
        }
        if (unmappedDirty.length > 0) {
          console.warn('Dirty sin mapeo a doc; se mandará a todos:', unmappedDirty);
          for (const t of targets) dirtyDocIds.add(t);
        }

        //    Estado completo por documento (solo de los dirty).
        //    Los elementos mapeados van a su doc; los no-mapeados se replican en
        //    todos los dirty docs (el conversor ignora ids que no existan en el IFC).
        const groupedPayload = {};
        for (const docId of dirtyDocIds) groupedPayload[docId] = {};

        for (const [globalId, data] of Object.entries(this.elementProgressMap)) {
          const docId = this._docIdForGlobalId(globalId);
          const pct = (data?.percentage == null) ? 0 : Number(data.percentage);
          const entry = {
            percentage: Math.max(0, Math.min(100, isNaN(pct) ? 0 : pct)),
            color: data?.color || null,
          };
          if (docId && dirtyDocIds.has(docId)) {
            groupedPayload[docId][globalId] = entry;
          } else if (!docId && this.dirtyElementIds[globalId]) {
            for (const d of dirtyDocIds) groupedPayload[d][globalId] = entry;
          }
        }

        const docIds = Object.keys(groupedPayload);
        if (docIds.length === 0) return;

        this.progressSyncState = 'saving';

        const results = await Promise.allSettled(docIds.map(docId =>
          axios.post(`/api/v2/ifc-document/${docId}/embed-progress`, {
            progressData: groupedPayload[docId],
          })
        ));

        const failed = [];
        results.forEach((r, i) => {
          if (r.status === 'rejected') {
            failed.push(docIds[i]);
            console.error(`embed-progress falló para doc ${docIds[i]}:`, r.reason);
          }
        });

        if (failed.length === 0) {
          this.$buefy?.toast?.open({
            message: this.$t('bim_progress_embed_sent'),
            type: 'is-success',
            duration: 4000,
          });
          this.dirtyElementIds = {};
          this.progressSyncState = 'idle';
        } else if (failed.length < docIds.length) {
          this.$buefy?.toast?.open({
            message: `${this.$t('bim_progress_sync_error')} (${failed.length}/${docIds.length})`,
            type: 'is-warning',
            duration: 5000,
          });
          this.progressSyncState = 'error';
        } else {
          this.$buefy?.toast?.open({
            message: this.$t('bim_progress_sync_error'),
            type: 'is-danger',
            duration: 5000,
          });
          this.progressSyncState = 'error';
        }
      },

      // Lee EPC_ProgressTracking de los metaObjects y puebla elementProgressMap.
      _loadProgressFromMeta() {
        if (!this.viewer?.metaScene?.metaObjects) return;
        const metaObjects = this.viewer.metaScene.metaObjects;
        const map = {};
        Object.keys(metaObjects).forEach(id => {
          const psets = metaObjects[id]?.propertySets || [];
          for (const pset of psets) {
            if (pset?.name !== 'EPC_ProgressTracking') continue;
            let percentage = null;
            let color = null;
            for (const p of (pset.properties || [])) {
              const n = (p?.name || '').toLowerCase();
              if (n === 'progresspercentage') {
                const v = Number(p.value);
                if (!Number.isNaN(v)) percentage = Math.round(v);
              } else if (n === 'progress' && percentage === null) {
                // IFCRATIOMEASURE 0-1 → porcentaje
                const v = Number(p.value);
                if (!Number.isNaN(v)) percentage = Math.round(v * 100);
              } else if (n === 'progressstatuscolor') {
                if (p.value) color = String(p.value);
              }
            }
            if (percentage !== null || color !== null) {
              map[id] = { percentage, color };
            }
          }
        });
        if (Object.keys(map).length > 0) {
          this.elementProgressMap = map;
        }
      },
    },

    beforeDestroy() {
      this.destroyAll();
    },
  };
  </script>

  <style>
  /* Canvas: ocupa 100% del .viewer-container que es quien fija el alto vía
     calc(100vh - 250px). Mantener el alto en un solo sitio evita desalineo. */
  #myCanvas {
    width: 100%;
    height: 100%;
    outline: none;
    overflow: hidden;
    display: block;
  }

  #myNavCubeCanvas {
    position: absolute;
    width: 150px;
    height: 150px;
    bottom: 100px;
    right: 50px;
    z-index: 200000;
    opacity: .7;
    transition: .2s opacity;
  }

  #myNavCubeCanvas:hover {
    opacity: 1;
  }

  .viewer-container {
    background-color: #2a2f3a;
    position: relative;
    font-family: 'Roboto', sans-serif;
    /* navbar (~80) + título sticky (~90) + topbar BIM compacta (~32). El p-4
       del <child> lo cancela el margin negativo de .bim-page en bim.vue. */
    height: calc(100vh - 202px);
    min-height: 320px;
  }

  .bim-loading-progress {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 320px;
    background: rgba(30, 35, 45, 0.95);
    border-radius: 8px;
    padding: 20px 25px;
    z-index: 999999;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .bim-loading-text {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .bim-loading-bar-container {
    width: 100%;
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    position: relative;
  }

  .bim-loading-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: #4a90d9;
    transition: width 0.3s ease;
  }

  .bim-loading-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .bim-loading-current {
    color: #a0aabf;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 4px;
  }

  .bim-loading-stop {
    background: rgba(255, 80, 80, 0.2);
    border: 1px solid rgba(255, 80, 80, 0.5);
    color: #ff8a8a;
    border-radius: 4px;
    padding: 6px 16px;
    font-size: 12px;
    cursor: pointer;
    margin-top: 10px;
    transition: all 0.2s;
  }

  .bim-loading-stop:hover {
    background: rgba(255, 80, 80, 0.8);
    color: white;
  }

  .left-panel {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 300px;
  }

  /* Conservado por compat: usado por overlays antiguos */
  .panel-item {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .panel-header {
    padding: 14px;
    display: flex;
    justify-content: space-between;
    font-size: .85em;
    font-weight: 500;
    color: #2f374a;
  }

  .panel-header>button {
    all: unset;
  }

  /* El panel ahora ocupa toda la altura disponible del viewer y deja que
     el tab activo ocupe todo el espacio (un único scroll en lugar de dos). */
  .panel-box {
    background: #f7f7f7;
    width: 320px;
    left: 60px;
    top: 10px;
    bottom: 10px;
    position: absolute;
    box-shadow: 0px 0px 10px #70707033;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 6px;
  }

  .panel-content {
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1 1 auto;
    min-height: 0;
    background: #ffffff;
    color: #2f374a;
    scrollbar-width: thin;
    scrollbar-color: #b0b6c2 transparent;
  }

  .panel-content.treeview {
    padding: 0px 14px;
  }

  #treeViewContainer {
    pointer-events: all;
    height: 100%;
    top: 0;
    z-index: 2;
    float: left;
    left: 0;
    font-size: 12px;
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  #treeViewContainer ul {
    list-style: none;
    padding-left: 1.35em;
    pointer-events: none;
    margin-top: 4px;
  }

  #treeViewContainer ul li {
    position: relative;
    width: auto;
    max-width: 100%;
    pointer-events: none;
    padding-top: 6px;
    padding-bottom: 1px;
    vertical-align: middle;
    word-break: break-word;
  }

  #treeViewContainer input {
    accent-color: #2f374a;
    vertical-align: top;
  }

  #treeViewContainer ul li a {
    border-radius: 50%;
    color: transparent;
    display: inline-block;
    height: 1.5em;
    left: -1.5em;
    position: absolute;
    text-align: center;
    text-decoration: none;
    width: 1.5em;
    pointer-events: all;
    font-weight: 800;
  }

  #treeViewContainer ul li a.plus::after {
    content: "❯";
    color: #2d2c32;
    font-size: 12px;
    display: inline-block;
    transition: transform 0.15s ease;
  }

  #treeViewContainer ul li a.minus::after {
    content: "❯";
    color: #2d2c32;
    font-size: 12px;
    display: inline-block;
    transform: rotate(90deg);
    transition: transform 0.15s ease;
  }

  #treeViewContainer ul li a.plus,
  #treeViewContainer ul li a.minus,
  #treeViewContainer ul li a:active {
    pointer-events: all;
  }

  #treeViewContainer ul li span:hover {
    cursor: pointer;
    background: #f9c62c5b;
  }

  #treeViewContainer ul li span.bim-tree-selected {
    background: #f9c72c !important;
    color: #2f374a;
    font-weight: 600;
    border-radius: 3px;
  }

  #treeViewContainer ul li span {
    display: inline-block;
    width: calc(100% - 24px);
    pointer-events: all;
    padding: 3px;
    vertical-align: bottom;
    word-break: break-word;
    line-height: 1.3;
  }

  .panel-content::-webkit-scrollbar,
  .panel-content::-moz-scrollbar {
    width: 8px;
  }

  .panel-content::-webkit-scrollbar-track,
  .panel-content::-moz-scrollbar-track {
    background: #7070708f;
  }

  .panel-content::-webkit-scrollbar-thumb,
  .panel-content::-moz-scrollbar-thumb {
    background: #7070708f;
    border-radius: 8px;
  }

  .panel-content::-webkit-scrollbar-thumb:hover,
  .panel-content::-moz-scrollbar-thumb:hover {
    background: #7070708f;
  }

  .bim-popup {
    position: absolute;
    z-index: 300000;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
    padding: 10px 14px;
    min-width: 180px;
    pointer-events: all;
  }

  .bim-popup-name {
    font-size: 12px;
    font-weight: 600;
    color: #2f374a;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 220px;
  }

  .bim-popup-uuid {
    font-size: 10px;
    color: #9aa0ab;
    margin-bottom: 8px;
    font-family: monospace;
  }

  .xeokit-context-menu {
    border: none !important;
    box-shadow: 0px 0px 10px #70707055 !important;
    min-width: 180px;
  }

  .xeokit-context-menu ul {
    margin: 0 !important;
    padding: 10px 0px !important;
  }

  .xeokit-context-menu li {
    all: unset;
    padding: 5px 15px;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: #2f374a;
    display: block;
  }

  .xeokit-context-menu-item-separator {
    height: 0px !important;
    padding: 0px !important;
    border-bottom: 1px solid #2f374a2f !important;
  }

  .xeokit-context-menu li:hover {
    background: #b0b0b027;
  }

  .tools {
    position: absolute;
    top: 0;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 5px;
  }

  .tools.left {
    left: 0;
  }

  .tools.right {
    right: 0;
  }

  .tools button {
    display: block;
    background: none;
    border: none;
    color: #2f374a;
    font-size: 22px;
    padding: 3px;
    cursor: pointer;
    width: 45px;
    height: 45px;
    border-radius: 1px;
    margin: 5px;
    background: #ffffff;
    box-shadow: 0px 0px 10px #70707033;
  }

  .tools button.active {
    background: #f9c72c;
  }

  .property {
    margin-top: 5px;
    font-size: 12px;
    box-shadow: 0px 0px 10px #70707033;
  }

  .property-title {
    margin: 8px 0px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    color: #2f374a;
    padding: 5px 14px;
  }

  .property-title button {
    all: unset;
  }

  .property-info {
    display: flex;
    padding: 12px 14px;
    color: #5d5d5d;
  }

  .property-info:nth-child(odd) {
    background-color: #f0f0f0;
  }

  .property-info:nth-child(even) {
    background-color: #ffffff;
  }

  .property-info-value {
    flex: 1;
  }

  .property-info-name {
    width: 35%;
    font-weight: bold;
  }

  .sk-fading-circle,
  .viewer-container>div:has(.sk-circle) {
    display: none !important;
  }

  /* Avance de obra — cabecera oscura destacada sobre el resto del panel */
  .bim-progress-card {
    margin: 8px 0;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e0e6f0;
    background: #fff;
  }

  .bim-progress-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: linear-gradient(135deg, #2f374a 0%, #3d4a63 100%);
    color: #fff;
    user-select: none;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  .bim-progress-header-icon {
    font-size: 13px;
    opacity: 0.75;
  }

  .bim-progress-badge {
    margin-left: auto;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 10px;
    padding: 2px 10px;
    font-size: 11px;
    font-weight: 700;
    transition: background 0.2s ease;
  }

  .bim-progress-chevron {
    margin-left: 4px;
    font-size: 11px;
    opacity: 0.8;
  }

  .bim-progress-body {
    padding: 12px 14px;
    background: #fafbfd;
  }

  .bim-progress-row {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 12px;
  }

  .bim-pct-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .bim-pct-input {
    width: 100px;
    border: 1.5px solid #dde2ea;
    border-radius: 6px;
    padding: 6px 22px 6px 8px;
    font-size: 14px;
    font-weight: 700;
    color: #2f374a;
    text-align: center;
    outline: none;
    background: #fff;
    transition: border-color 0.15s;
  }

  .bim-pct-input:focus {
    border-color: #2f374a;
  }

  .bim-pct-input::-webkit-outer-spin-button,
  .bim-pct-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .bim-pct-symbol {
    position: absolute;
    right: 8px;
    font-size: 12px;
    color: #9aa0ab;
    font-weight: 600;
    pointer-events: none;
  }

  .bim-pct-bar-track {
    flex: 1;
    height: 8px;
    background: #eaeef3;
    border-radius: 4px;
    overflow: hidden;
  }

  .bim-pct-bar-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease, background 0.3s ease;
    min-width: 0;
  }

  .bim-swatches {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
  }

  .bim-swatch {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 6px 2px;
    border: 1.5px solid #e4e8ef;
    border-radius: 7px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    min-width: 0;
  }

  .bim-swatch:hover {
    background: #f5f7fb;
    border-color: #c5ccd8;
  }

  .bim-swatch.selected {
    border-color: #2f374a;
    background: #eef1f6;
  }

  .bim-swatch-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.08);
    flex-shrink: 0;
  }

  .bim-swatch-check {
    color: #fff;
    font-size: 10px;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  }

  .bim-swatch-lbl {
    font-size: 9px;
    color: #5d6b82;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    line-height: 1.2;
    text-align: center;
    font-weight: 500;
  }

  /* Posicionada en top-center, fuera de la zona del tree (que vive a la izquierda). */
  .bim-embed-bar {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 250000;
    padding: 8px 12px;
    background: linear-gradient(135deg, #fff8e1, #fffde7);
    border: 1px solid #ffe082;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .bim-embed-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    color: #7a5a00;
    font-weight: 500;
    min-width: 0;
  }

  .bim-embed-count {
    background: #f9c72c;
    color: #2f374a;
    font-weight: 800;
    font-size: 13px;
    min-width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0 4px;
  }

  .bim-embed-btn {
    background: #2f374a;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 7px 12px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;
  }

  .bim-embed-btn:hover {
    background: #f9c72c;
    color: #2f374a;
  }

  .bim-embed-btn:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .bim-embed-cancel {
    all: unset;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: #b3660a;
    border: 1.5px solid #e0b96a;
    border-radius: 50%;
    cursor: pointer;
    font-size: 11px;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
    flex-shrink: 0;
  }

  .bim-embed-cancel:hover:not(:disabled) {
    background: #f44336;
    color: #fff;
    border-color: #f44336;
  }

  .bim-embed-cancel:disabled {
    opacity: 0.4;
    cursor: default;
  }

  .bim-annot-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
    z-index: 1500;
  }

  .bim-annot-marker {
    position: absolute;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    white-space: nowrap;
    pointer-events: none;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    border: 1.5px solid #fff;
  }

  /* === Modo 2D Blueprint === */
  .viewer-container.is-view2d #myNavCubeCanvas {
    opacity: 0.35;
  }

  /* POI estilo dashboard — pin con etiqueta y KPI sobre elementos eléctricos */
  .bim-poi-marker {
    position: absolute;
    transform: translate(-50%, -100%);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px 4px 6px;
    background: rgba(15, 22, 35, 0.92);
    border: 1px solid var(--poi-color, #4adfff);
    border-radius: 14px;
    color: #e8f4ff;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2px;
    box-shadow:
      0 0 0 2px rgba(74, 223, 255, 0.08),
      0 4px 14px rgba(0, 0, 0, 0.45);
    pointer-events: none;
    white-space: nowrap;
    backdrop-filter: blur(4px);
  }

  .bim-poi-marker::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -5px;
    width: 8px;
    height: 8px;
    background: var(--poi-color, #4adfff);
    transform: translateX(-50%) rotate(45deg);
    border-bottom-right-radius: 2px;
    box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);
  }

  .bim-poi-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--poi-color, #4adfff);
    box-shadow: 0 0 8px var(--poi-color, #4adfff);
    flex-shrink: 0;
  }

  .bim-poi-label {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bim-poi-kpi {
    background: var(--poi-color, #4adfff);
    color: #0c1422;
    border-radius: 8px;
    padding: 1px 6px;
    font-size: 10px;
    font-weight: 800;
  }

  /* === Panel izquierdo: tabs (estructura/propiedades) ============= */
  .panel-tabs {
    display: flex;
    background: #2f374a;
    flex-shrink: 0;
  }

  .panel-tab {
    all: unset;
    flex: 1;
    padding: 10px 8px;
    text-align: center;
    color: #b9c0cf;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-bottom: 2px solid transparent;
    transition: color 0.15s, background 0.15s, border-color 0.15s;
    position: relative;
  }

  .panel-tab:hover {
    color: #fff;
    background: rgba(255,255,255,0.04);
  }

  .panel-tab.active {
    color: #f9c72c;
    border-bottom-color: #f9c72c;
    background: rgba(249, 199, 44, 0.08);
  }

  .panel-tab i {
    font-size: 13px;
  }

  /* Punto de notificación cuando hay un elemento cargado en propiedades pero
     la pestaña activa es otra. Da feedback de que hay info nueva sin forzar
     el cambio de tab. */
  .panel-tab-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #f9c72c;
    margin-left: 4px;
    box-shadow: 0 0 0 2px rgba(249, 199, 44, 0.25);
  }

  .panel-tab.active .panel-tab-dot {
    display: none;
  }

  .panel-tab-pane {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  /* Buscador del árbol */
  .tree-search {
    position: relative;
    padding: 8px 10px;
    background: #fff;
    border-bottom: 1px solid #e4e8ef;
    flex-shrink: 0;
  }

  .tree-search-icon {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #9aa0ab;
    font-size: 12px;
    pointer-events: none;
  }

  .tree-search-input {
    width: 100%;
    padding: 6px 28px 6px 28px;
    border: 1.5px solid #dde2ea;
    border-radius: 6px;
    font-size: 12px;
    color: #2f374a;
    background: #fff;
    outline: none;
    transition: border-color 0.15s;
  }

  .tree-search-input:focus {
    border-color: #2f374a;
  }

  .tree-search-clear {
    all: unset;
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #9aa0ab;
    cursor: pointer;
    border-radius: 50%;
    font-size: 11px;
  }

  .tree-search-clear:hover {
    background: #eee;
    color: #2f374a;
  }

  /* Estado vacío de propiedades cuando no hay elemento seleccionado */
  .panel-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 20px;
    text-align: center;
    color: #9aa0ab;
    font-size: 12px;
  }

  .panel-empty-icon {
    font-size: 28px;
    margin-bottom: 10px;
    opacity: 0.5;
  }

  /* Panel de propiedades: scroll único, sin doble nesting */
  .panel-properties {
    position: relative;
  }

  /* Card de Avance: fija fuera del scroll. Antes vivía dentro del flujo y se
     perdía cuando el usuario revisaba propertysets largos. Como sticky chocaba
     con los headers de pset (también sticky), la sacamos del scroll. */
  .bim-progress-card.is-fixed-top {
    margin: 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
    flex-shrink: 0;
  }

  /* Property-title sticky: al scrollear, el header del pset queda anclado para
     que el usuario sepa qué propertyset está mirando. */
  .property-title.is-sticky {
    position: sticky;
    top: 0;
    z-index: 5;
    background: #f0f0f0;
    margin: 0;
    cursor: pointer;
    user-select: none;
    border-bottom: 1px solid #e4e8ef;
  }

  .property-title.is-sticky:hover {
    background: #e8e8e8;
  }

  .property-count {
    font-weight: 400;
    color: #9aa0ab;
    font-size: 11px;
    margin-left: 4px;
  }

  </style>